/**
 * Phase 14: Content Domination Engine — JavaScript
 * - Reading progress bar
 * - Auto-generated Table of Contents from H2/H3
 * - Scroll-spy for TOC active state
 * - Floating share/TOC visibility control
 */
(function () {
  'use strict';

  // Gate: only run on article pages
  var engine = document.getElementById('seo-content-engine');
  if (!engine) return;

  var articleContent = document.querySelector('.blog-post-content, [class*="blog-post"] [class*="content"], article, .rte');
  if (!articleContent) {
    // Try broader selector
    articleContent = document.querySelector('.section-content-wrapper');
  }

  // ── Reading Progress Bar ──
  var progressBar = document.getElementById('sce-progress');
  if (progressBar) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollTop = window.scrollY || document.documentElement.scrollTop;
          var docHeight = document.documentElement.scrollHeight - window.innerHeight;
          var pct = docHeight > 0 ? Math.min((scrollTop / docHeight) * 100, 100) : 0;
          progressBar.style.width = pct + '%';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── Auto-generate Table of Contents ──
  var tocList = document.getElementById('sce-toc-list');
  var tocContainer = document.getElementById('sce-toc');
  var headings = [];

  if (tocList && articleContent) {
    var hElements = articleContent.querySelectorAll('h2, h3');
    if (hElements.length >= 2) {
      hElements.forEach(function (h, i) {
        var id = 'sce-h-' + i;
        h.id = id;
        var level = h.tagName.toLowerCase();
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.trim();
        if (level === 'h3') a.classList.add('sce-toc-h3');
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(id);
          if (target) {
            var y = target.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        });
        li.appendChild(a);
        tocList.appendChild(li);
        headings.push({ id: id, el: h, link: a });
      });
    } else if (tocContainer) {
      tocContainer.style.display = 'none';
    }
  }

  // ── Scroll-spy for TOC + visibility toggle ──
  var share = document.getElementById('sce-share');
  var lastActive = null;

  function onScroll() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;

    // Show/hide floating elements after scrolling 300px
    var show = scrollTop > 300;
    if (share) share.classList.toggle('sce-show', show);
    if (tocContainer && headings.length >= 2) tocContainer.classList.toggle('sce-show', show);

    // Scroll-spy
    if (headings.length > 0) {
      var current = null;
      for (var i = headings.length - 1; i >= 0; i--) {
        var rect = headings[i].el.getBoundingClientRect();
        if (rect.top <= 120) {
          current = headings[i];
          break;
        }
      }
      if (current !== lastActive) {
        if (lastActive) lastActive.link.classList.remove('sce-active');
        if (current) current.link.classList.add('sce-active');
        lastActive = current;
      }
    }
  }

  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (!scrollTicking) {
      requestAnimationFrame(function () {
        onScroll();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  // ── Auto-detect FAQ sections and inject FAQPage schema ──
  if (articleContent) {
    var faqPairs = [];
    var potentialQs = articleContent.querySelectorAll('h2, h3, strong, b');

    potentialQs.forEach(function (q) {
      var text = q.textContent.trim();
      // Detect question patterns
      if (text.match(/\?$/) || text.match(/^(what|how|why|when|where|which|can|does|is|are|do|should|will)/i)) {
        var answer = '';
        var next = q.nextElementSibling;
        while (next && !next.matches('h2, h3')) {
          answer += next.textContent.trim() + ' ';
          next = next.nextElementSibling;
          if (!next || answer.length > 500) break;
        }
        answer = answer.trim();
        if (answer.length > 20) {
          faqPairs.push({ q: text.replace(/\?$/, '') + '?', a: answer });
        }
      }
    });

    if (faqPairs.length >= 2) {
      var faqSchema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqPairs.slice(0, 10).map(function (pair) {
          return {
            '@type': 'Question',
            name: pair.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: pair.a
            }
          };
        })
      };
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(faqSchema);
      document.head.appendChild(script);
    }
  }

  // Initial call
  onScroll();
})();
